import getWidget from './getWidget';
import getWidgets  from './getWidgets';

import injectDefaults from './injectDefaults';
import getWidgetPreview from './getWidgetPreview';

export const actions = {
    getWidget,
    getWidgets,
    injectDefaults,
    getWidgetPreview,
};

export default actions;
